import { useState } from 'react';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { ExamTaskGroupCoordinator, ITaskGroup } from '../../../models/taskGroup.types';
import { addExamTaskGroupCoordinatorToSampleAssessmentGroupChairman } from '../../../services/exams/examiningTeam/examiningTeam.service';
import { SelectExamTaskGroupCoordinatorDialog } from './SelectExamTaskGroupCoordinatorDialog.component';
import { AxiosError, AxiosResponse } from 'axios';
import { ValidationResult } from '../../../services/validation/validation.service';

export const SampleAssessmentGroupChairmanAssignDialog: React.FC<{
  taskGroup: ITaskGroup;
  sampleAssessmentId: string;
  onSuccess: () => void;
  onFailure: () => void;
}> = (props) => {
  const [isExamTaskGroupCoordinatorSelectDialogVisible] = useState<boolean>(true);
  const [isSuccessPromptVisible, setIsSuccessPromptVisible] = useState<boolean>(false);
  const [isFailurePromptVisible, setIsFailurePromptVisible] = useState<boolean>(false);

  const [errorDuringSampleAssessmentGroupCreation] = useState<boolean>(false);

  const [selectedTaskGroupCoordinator, setSelectedTaskGroupCoordinator] = useState<ExamTaskGroupCoordinator>();

  const assignSelectedTaskGroupCoordinatorAsChairmanInSampleAssessmentGroup = (
    sampleAssessmentId: string,
    selectedExaminerId: string,
  ) => {
    addExamTaskGroupCoordinatorToSampleAssessmentGroupChairman(sampleAssessmentId, selectedExaminerId).then(
      (
        result: AxiosResponse<{ sampleAssessmenGroupChairmanId: { id: string; verificationResult: ValidationResult } }>,
      ) => {
        switch (result.data.sampleAssessmenGroupChairmanId.verificationResult) {
          case ValidationResult.Valid:
            setIsSuccessPromptVisible(true);
            break;
          default:
            setIsFailurePromptVisible(true);
            break;
        }
      },
      (error: AxiosError) => {
        setIsFailurePromptVisible(true);
        console.log(error);
      },
    );
  };

  const getAssignedRoleName = () => {
    return 'Przewodniczącego ZWO';
  };

  const getPromptMainText = () => {
    if (errorDuringSampleAssessmentGroupCreation) {
      return 'Zespołu Wzorcowych Ocen (ZWO) dla';
    } else return `Przypisanie funkcji ${getAssignedRoleName()} Egzaminatorowi:`;
  };

  const getPromptSubTexts = (isSuccess?: boolean) => {
    if (selectedTaskGroupCoordinator)
      return [
        {
          text: selectedTaskGroupCoordinator.examiner.firstName + ' ' + selectedTaskGroupCoordinator.examiner.lastName,
        },
        {
          text: isSuccess ? 'zakończone sukcesem.' : 'nie powiodło się, spróbuj ponownie później.',
          isBold: true,
        },
      ];
  };

  return (
    <>
      {props.taskGroup && (
        <SelectExamTaskGroupCoordinatorDialog
          open={isExamTaskGroupCoordinatorSelectDialogVisible}
          taskGroupCoordinators={props.taskGroup.examTaskGroupCoordinators.filter(
            (taskGroupCoordinator) => taskGroupCoordinator.examiner,
          )}
          isSampleAssessmentGroupJustCreated={false}
          taskGroupId={props.taskGroup.taskGroupId}
          onSelect={(selectedTaskGroupCoordinator: ExamTaskGroupCoordinator) => {
            setSelectedTaskGroupCoordinator(selectedTaskGroupCoordinator);
            assignSelectedTaskGroupCoordinatorAsChairmanInSampleAssessmentGroup(
              props.sampleAssessmentId,
              selectedTaskGroupCoordinator.examiner.examinerId,
            );
          }}
          onCancel={() => props.onFailure()}
        />
      )}
      <Prompt
        type="success"
        isBold={true}
        open={isSuccessPromptVisible}
        mainText={getPromptMainText()}
        subTexts={getPromptSubTexts(true)}
        onConfirm={() => props.onSuccess()}
        mainActionButtonText="POWRÓT DO LISTY"
      />
      <Prompt
        type="error"
        isBold={true}
        open={isFailurePromptVisible}
        mainText={getPromptMainText()}
        subTexts={getPromptSubTexts()}
        onConfirm={() => props.onFailure()}
        mainActionButtonText="POWRÓT DO LISTY"
      />
    </>
  );
};
